import React from 'react';
import FileUpload from '../../../components/flashcheck/FileUpload';
import {
  ContentPadding
} from './styled';

interface UploadTabProps {
  loading: boolean;
  error: string | null;
  uploadSuccess: boolean;
  setUploadSuccess: (success: boolean) => void;
  setError: (error: string | null) => void;
  loadFiles: (path?: string) => Promise<void>;
  onUploadComplete?: () => void;
  onSwitchToLibrary?: () => void;
}

export const UploadTab: React.FC<UploadTabProps> = ({
  loading,
  error,
  uploadSuccess,
  setUploadSuccess,
  setError,
  loadFiles,
  onUploadComplete,
  onSwitchToLibrary
}) => {
  const handleUploadComplete = () => {
    setUploadSuccess(true);
    loadFiles(); // Refresh the file list
    setTimeout(() => setUploadSuccess(false), 3000);
    onUploadComplete?.(); // Call parent callback if provided
  };

  return (
    <ContentPadding>
      <FileUpload 
        currentPath=""
        onUploadComplete={handleUploadComplete}
      />
      
      {uploadSuccess && (
        <div style={{ 
          marginTop: '16px', 
          padding: '16px', 
          backgroundColor: 'rgba(16, 185, 129, 0.1)', 
          border: '1px solid rgba(16, 185, 129, 0.3)', 
          borderRadius: '12px', 
          color: '#10b981',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '18px' }}>✅</span>
            <strong>File uploaded successfully!</strong>
          </div>
          <p style={{ margin: 0, lineHeight: '1.5', color: '#059669' }}>
            Your document has been uploaded and processing will begin shortly. 
            Once processed, the FlashCheck result will be available in the FlashCheck Library.
          </p>
        </div>
      )}

      {error && (
        <div style={{ 
          marginTop: '16px', 
          padding: '12px', 
          backgroundColor: 'rgba(239, 68, 68, 0.1)', 
          border: '1px solid rgba(239, 68, 68, 0.3)', 
          borderRadius: '8px', 
          color: '#ef4444' 
        }}>
          ❌ {error}
        </div>
      )}
    </ContentPadding>
  );
};
